export class StructureColumnTracking {
    // staff
    structures;

    constructor() {
        this.init();
    }

    init() {
        this.structures = $('.structure--col-3');

        if (!this.structures.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.structures
            .on('click', '.pagination-control button', (e) => this.onPagination(e))
            .on('click', '.card__kicker a.lnk', (e) => this.onKicker(e))
            .on('click', '.card__heading a.lnk', (e) => this.onHeading(e))
            .on('click', '.media-image .media-info', (e) => this.onMediainfo(e))
            .on('click', '.media-image a.oop-link', (e) => this.onMediaImage(e));
    }

    onPagination(e) {
        const button = $(e.target);

        this.sendGTMEvent({
            bloque: this.getStructureTitleText(button),
            direccion: this.getPaginationDirection(button),
            event: 'relacionados_paginacion'
        });
    }

    onKicker(e) {
        const button = $(e.target);

        this.sendGTMEvent({
            bloque: this.getStructureTitleText(button),
            posicion: this.getSlidePosition(button),
            programa: this.getNameText(button),
            event: 'relacionados_programa'
        });
    }

    onHeading(e) {
        const button = $(e.target);

        this.sendGTMEvent({
            bloque: this.getStructureTitleText(button),
            posicion: this.getSlidePosition(button),
            noticia: this.getNameText(button),
            event: 'relacionados_noticia'
        });
    }

    onMediainfo(e) {
        const button = $(e.target);

        this.sendGTMEvent({
            bloque: this.getStructureTitleText(button),
            posicion: this.getSlidePosition(button),
            noticia: this.getNameText(button),
            event: 'relacionados_flecha'
        });
    }

    onMediaImage(e) {
        const button = $(e.target);

        const data = {
            bloque: this.getStructureTitleText(button),
            posicion: this.getSlidePosition(button),
            noticia: this.getNameText(button),
            event: 'relacionados_imagen'
        };

        if (this.isMediainfo(button.siblings('.media-info'), e)) {
            data.event = 'relacionados_flecha';
        }

        this.sendGTMEvent(data);
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Structure event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getStructureTitleText(button) {
        return button.closest('.structure').find('.section-header__title').text() || '';
    }

    getPaginationDirection(button) {
        return button.is('.pagination-control__navigation--prev') ? 'izq' : 'drc';
    }

    getSlidePosition(button) {
        return button.closest('.slider__slide').index() + 1;
    }

    getNameText(button) {
        return button.text() || '';
    }

    isMediainfo(mediainfo, e) {
        if (!mediainfo.length) {
            return false;
        }

        const bounds = mediainfo.get(0).getBoundingClientRect();
        const boundX = [bounds.x, bounds.x + bounds.width];
        const boundY = [bounds.y, bounds.y + bounds.height];

        return (boundX[0] <= e.clientX && e.clientX <= boundX[1]) && (boundY[0] <= e.clientY && e.clientY <= boundY[1]);
    }
}
